// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1teoC","content":"styles_content__2nXVp"};